<template>
  <div id="TemplateLogin">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'TemplateLogin',
}
</script>



// WEBPACK FOOTER //
// src/components/Template/Login.vue